import { Text } from '@sitecore-jss/sitecore-jss-react';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrdinal } from '../../../utils/dateUtils/dateUtils';
import { updatePaymentDay } from '../../../redux/slices/quoteDataSlice';
import PropTypes from 'prop-types';
import Tooltip from '../../common/Tooltip';

export const MAX_PAYMENT_DATE = 28;

const PaymentDayDropDown = ({ fields }) => {
  const dispatch = useDispatch();

  const showPreferredPaymentDaySelector = useSelector(
    state => state.quoteData.prospectDetails.showPreferredPaymentDaySelector
  );
  const selectedPaymentDay = useSelector(
    state => state.quoteData.prospectDetails.bankDetails?.paymentDay
  );
  const setSelectedPaymentDay = day => {
    if (day > 0) {
      dispatch(updatePaymentDay(day));
    }
  };

  return (
    <>
      {showPreferredPaymentDaySelector && (
        <div className="vds-form__group vds-form-group--limited-width">
          <label className="vds-form__label">
            {fields.preferredPaymentDateLabel?.value}
            {fields.tooltipText?.value && (
              <Tooltip tooltipText={fields.tooltipText} fields={fields} />
            )}
          </label>
          <Text
            tag="p"
            field={fields.preferredPaymentDateSubTitle}
            data-testid={`${fields.testid?.value}-subtitle`}
          />
          <select
            className="vds-form__input vds-form__input--select"
            value={selectedPaymentDay ?? ''}
            onChange={e => setSelectedPaymentDay(Number(e.target.value))}
          >
            {fields.placeholder?.value && <option value="">{fields.placeholder.value}</option>}
            {Array.from({ length: MAX_PAYMENT_DATE }, (_, i) => i + 1).map(day => (
              <option key={day} value={day}>
                {getOrdinal(day)}
              </option>
            ))}
          </select>
        </div>
      )}
    </>
  );
};

PaymentDayDropDown.propTypes = {
  fields: PropTypes.shape({
    preferredPaymentDateLabel: PropTypes.shape({
      value: PropTypes.string,
    }),
    preferredPaymentDateSubTitle: PropTypes.shape({
      value: PropTypes.string,
    }),
    testid: PropTypes.shape({
      value: PropTypes.string,
    }),
    placeholder: PropTypes.shape({
      value: PropTypes.string,
    }),
    tooltipText: PropTypes.shape({
      value: PropTypes.string,
    }),
  }),
};
export default PaymentDayDropDown;
